import { W as WuiBox$1, d as defineCustomElement$1 } from './box.js';

const WuiBox = WuiBox$1;
const defineCustomElement = defineCustomElement$1;

export { WuiBox, defineCustomElement };

//# sourceMappingURL=wui-box.js.map